module.exports = __webpack_public_path__ + "img/angst_640.831ba6e6.webp";